import {ChangeDetectionStrategy, Component, Input, OnInit} from "@angular/core";
import {Company, Order} from "../../../../store/state/order.state";
import {ChangeSet} from "../../history/order-history.model";
import {Observable} from "rxjs";
import {ConfigurationProvider} from "../../../../configuration/configuration.provider";
import {map} from "rxjs/operators";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'address-details',
    templateUrl: './address-details.template.html',
    styleUrls: ['./address-details.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AddressDetailsComponent implements OnInit {

	readonly RANDOM_NUMBER: number = Math.random();

	private company: Company;

	@Input() order: Order;
	@Input() changeSet: ChangeSet; // optional
	@Input() showMultiSiteQuestion: boolean = true;
	@Input() isBillingAddress: boolean = false;

	constructor(private configProvider: ConfigurationProvider, private translate: TranslateService) {
	}

	ngOnInit(): void {
		this.company = this.isBillingAddress ? this.order.billingInformations.billingCompany : this.order.company;
	}

	private formatAddress(company: Company): string {
		let country: string = company.country ? this.translate.instant(`common.country.${this.order.clientCountry.toLowerCase()}`) : '';
		return `${company.street ? company.street + ',' : ''} ${company.zipCode ? company.zipCode + ',' : ''} ${company.city ? company.city + ',' : ''} ${company.state ? company.state + ',' : ''} ${country}`;
	}

	get address(): string {
		return this.formatAddress(this.isBillingAddress ? this.order.billingInformations.billingCompany : this.order.company);
	}

	get companyName(): string {
		return this.isBillingAddress ? this.order.billingInformations.billingCompany.name : this.order.company.name;
	}

	isAddressChanged(): boolean {
		return !!this.changeSet && [this.changeSet.changes.company.city, this.changeSet.changes.company.state, this.changeSet.changes.company.street,
			this.changeSet.changes.company.country, this.changeSet.changes.company.zipCode].some(val => !!val);
	}

	isCompanyNameChanged() {
		return !!this.changeSet && !!this.changeSet.changes.company.name;
	}

	showKvkNr(): Observable<boolean> {
		return this.configProvider.getConfigurationFor(this.order.clientCountry).pipe(map(config => config.clientCountryConfig?.order.additionalParamsIncluded['kvkNr']));
	}

	showTaxId(): Observable<boolean> {
		return this.configProvider.getConfigurationFor(this.order.clientCountry).pipe(map(config => config.clientCountryConfig?.order.additionalParamsIncluded['taxId']));
	}

	isKvkNrChanged() {
		return !!this.changeSet && !!this.changeSet.changes.company.kvkNr;
	}

	isTaxIdChanged() {
		return !!this.changeSet && !!this.changeSet.changes.company.taxId;
	}
}
